import { render } from "./UserPage.vue?vue&type=template&id=decdffae&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user/UserPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "decdffae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('decdffae', __exports__)) {
    api.reload('decdffae', __exports__)
  }
  
  module.hot.accept("./UserPage.vue?vue&type=template&id=decdffae&ts=true", () => {
    api.rerender('decdffae', render)
  })

}


export default __exports__